import { PaginatedSubentityStateModel } from 'app/projects/subentity/src/lib/models/paginated-subentity.state-model';

export class ModuleParticipantsStateModel extends PaginatedSubentityStateModel {
    static identifier = 'ModuleParticipantsStateModel';

    constructor() {
        super(ModuleParticipantsStateModel.identifier);
    }
}
